import { createApp } from "vue";
import App from "./App.vue";

// import VueTrix from 'vue-trix';

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueQRCodeComponent from 'vue-qrcode-component';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// import VueQuillEditor from 'vue-quill-editor'
 
// require styles
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'



//imports for app initialization
import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { Settings} from 'luxon'
import { computed, ref } from 'vue'

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);

Settings.defaultZone = "Asia/Bangkok"
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueLoading, { color: "#0095E8" });
app.use(VueSweetalert2);
app.component('qr-code', VueQRCodeComponent) 
app.component('QuillEditor', QuillEditor)
// app.use(VueQuillEditor, /* { default global options } */)
// app.use(Vue2Editor);


const partnerCode = ref("");
app.config.globalProperties.$selectedPartnerCode = computed({
    get: () => partnerCode.value,
    set: value => partnerCode.value = value,
})

ApiService.init(app);
// MockAdapter.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
